import type { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import NosotrosPage from '@/pages/nosotros/page';
import ServiciosPage from '@/pages/servicios/page';
import ContactoPage from '@/pages/contacto/page';
import SuperuserPage from '@/pages/superuser/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/superuser',
    element: <SuperuserPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;